import { Icon, IconName } from "@zapier/zinnia-icons";
import styles from "./AssetNodeSkeleton.module.css";

interface AssetIconProps {
  /** Name of the icon to display (required). */
  iconName: IconName;
}

/**
 * Reusable AssetIcon component for AssetNodeSkeleton footer.
 *
 * Displays a small (16 px) icon with the standard footer styling.
 * `iconName` is required so callers consciously decide which icon to render.
 */
export function AssetIcon({ iconName }: AssetIconProps) {
  return (
    <div className={styles.iconContainer}>
      <Icon name={iconName} color="BrandOrange" size={16} />
    </div>
  );
}
